import { apiFetch } from './client';

export const callsApi = {
  list: (filters = {}) =>
    apiFetch('/api/calls', {
      params: {
        campaign_id: filters.campaignId,
        lead_id: filters.leadId,
        status: filters.status,
        limit: filters.limit,
      },
    }),
  queue: () => apiFetch('/api/calls/queue'),
  inbound: () => apiFetch('/api/calls/inbound'),
  get: (id) => apiFetch(`/api/calls/${id}`),
  initiate: (data) => apiFetch('/api/calls', { method: 'POST', body: data }),
  cancel: (id) => apiFetch(`/api/calls/${id}/cancel`, { method: 'POST' }),
  cancelAll: () => apiFetch('/api/calls/cancel-all', { method: 'POST' }),
  sync: (id) => apiFetch(`/api/calls/${id}/sync`, { method: 'POST' }),
  tagOutcome: (id, outcome) =>
    apiFetch(`/api/calls/${id}/outcome`, { method: 'PATCH', body: outcome }),
  recording: (id) => apiFetch(`/api/calls/${id}/recording`, { raw: true }),
};
